import { useEffect } from 'react';

function ScrollToTopOnMount() {
  useEffect(() => {
    typeof window !== 'undefined' && window.scrollTo(0, 0);
  }, []);

  return null;
}

export default ScrollToTopOnMount;
